import * as React from "react";

interface Props {
  style?: any;
}

export const Amex = ({ style }: Props): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 120 80"
    style={{ ...style }}
  >
    <defs>
      <linearGradient id="amex_a" x1="5.1%" x2="100%" y1="5.1%" y2="100%">
        <stop offset="0%" stopColor="#51AAD6" />
        <stop offset="100%" stopColor="#1D3A90" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <rect width="120" height="80" fill="url(#amex_a)" rx="4" />
      <path
        fill="#FFF"
        d="M27.557 28.241L18 49.971h11.445l1.416-3.465h3.245l1.415 3.465h12.596v-2.643l1.12 2.643h6.52l1.12-2.702v2.702h26.194l3.186-3.377 2.979 3.377 13.45.029L93.1 39.165l9.587-10.924H89.442l-3.097 3.319-2.89-3.319H54.96l-2.448 5.609-2.507-5.609H38.589v2.555l-1.268-2.555h-9.764zm2.212 3.084h5.575l6.342 14.74v-14.74h6.106l4.897 10.57 4.513-10.57h6.076v15.592h-3.687l-.03-12.215-5.397 12.215H50.86l-5.428-12.215v12.215h-7.61l-1.445-3.494H28.59l-1.446 3.494h-4.07l6.695-15.592zm36.901 0h15.044l4.602 5.109 4.749-5.11h4.601l-6.99 7.84 6.99 7.753h-4.808l-4.601-5.168-4.779 5.168H66.67V31.325zm-34.187 2.642l-2.566 6.226h5.132l-2.566-6.226zm37.904.588v2.848h8.2v3.171h-8.2v3.113h9.203l4.277-4.58-4.1-4.552h-9.38z"
      />
    </g>
  </svg>
);
export const AmexV2 = ({ style }: Props): React.ReactElement => (
  <svg
    width="39"
    height="20"
    viewBox="0 0 39 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <g id="Visa">
      <rect
        x="0.349951"
        y="0.15"
        width="37.7"
        height="19.7"
        rx="3.85"
        fill="white"
      />
      <path
        id="amex"
        d="M8.05019 6.0005L6.79907 8.90941H7.61362L7.84447 8.3269H9.1865L9.41613 8.90941H10.2486L8.99867 6.0005H8.05019ZM8.51308 6.67747L8.92214 7.69538H8.10283L8.51308 6.67747ZM10.3347 8.90891V6L11.4922 6.00429L12.1655 7.87979L12.8226 6H13.9709V8.90891H13.2437V6.7655L12.4728 8.90891H11.835L11.062 6.7655V8.90891H10.3347ZM14.4685 8.90891V6H16.8415V6.65067H15.2033V7.14824H16.8032V7.76067H15.2033V8.27739H16.8415V8.90891H14.4685ZM17.2626 6.0005V8.90941H17.9898V7.87597H18.296L19.1679 8.90941H20.0566L19.0998 7.83769C19.4925 7.80455 19.8976 7.4675 19.8976 6.94421C19.8976 6.33209 19.4171 6.0005 18.8809 6.0005H17.2626ZM17.9898 6.65117H18.8211C19.0205 6.65117 19.1655 6.80715 19.1655 6.95736C19.1655 7.1506 18.9776 7.26357 18.8318 7.26357H17.9898V6.65117ZM20.937 8.90891H20.1944V6H20.937V8.90891ZM22.6976 8.90891H22.5374C21.7619 8.90891 21.291 8.29793 21.291 7.46641C21.291 6.61433 21.7566 6 22.7359 6H23.5397V6.68895H22.7065C22.309 6.68895 22.0278 6.99921 22.0278 7.47358C22.0278 8.03694 22.3493 8.27354 22.8124 8.27354H23.0038L22.6976 8.90891ZM24.2801 6.0005L23.029 8.90941H23.8435L24.0743 8.3269H25.4164L25.646 8.90941H26.4785L25.2286 6.0005H24.2801ZM24.743 6.67747L25.152 7.69538H24.3327L24.743 6.67747ZM26.5634 8.90891V6H27.488L28.6685 7.82764V6H29.3958V8.90891H28.5011L27.2906 7.03344V8.90891H26.5634ZM12.0954 13.9995V11.0906H14.4685V11.7413H12.8303V12.2389H14.4302V12.8513H12.8303V13.368H14.4685V13.9995H12.0954ZM23.7234 13.9995V11.0906H26.0965V11.7413H24.4583V12.2389H26.0505V12.8513H24.4583V13.368H26.0964V13.9995H23.7234ZM14.5606 13.9995L15.716 12.563L14.533 11.0906H15.4493L16.1538 12.0008L16.8607 11.0906H17.741L16.5736 12.545L17.7312 13.9995H16.8151L16.1311 13.1036L15.4636 13.9995H14.5606ZM17.8176 11.0911V14H18.5639V13.0814H19.3294C19.9771 13.0814 20.4681 12.7378 20.4681 12.0695C20.4681 11.5159 20.083 11.0911 19.4239 11.0911H17.8176ZM18.5639 11.749H19.3701C19.5793 11.749 19.7289 11.8772 19.7289 12.0838C19.7289 12.278 19.5801 12.4188 19.3677 12.4188H18.5639V11.749ZM20.7839 11.0906V13.9995H21.5111V12.9661H21.8173L22.6893 13.9995H23.5779L22.6211 12.9278C23.0138 12.8947 23.4189 12.5576 23.4189 12.0343C23.4189 11.4222 22.9384 11.0906 22.4022 11.0906H20.7839ZM21.5111 11.7413H22.3424C22.5418 11.7413 22.6869 11.8973 22.6869 12.0475C22.6869 12.2407 22.4989 12.3537 22.3532 12.3537H21.5111V11.7413ZM26.4333 13.9995V13.368H27.8887C28.104 13.368 28.1973 13.2516 28.1973 13.124C28.1973 13.0017 28.1043 12.8781 27.8887 12.8781H27.231C26.6593 12.8781 26.3409 12.5298 26.3409 12.0068C26.3409 11.5404 26.6325 11.0906 27.482 11.0906H28.8982L28.592 11.7451H27.3672C27.1331 11.7451 27.061 11.868 27.061 11.9853C27.061 12.1058 27.1501 12.2389 27.3289 12.2389H28.0179C28.6551 12.2389 28.9317 12.6003 28.9317 13.0737C28.9317 13.5827 28.6235 13.9995 27.9832 13.9995H26.4333ZM29.1024 13.9995V13.368H30.5578C30.7732 13.368 30.8664 13.2516 30.8664 13.124C30.8664 13.0017 30.7734 12.8781 30.5578 12.8781H29.9001C29.3284 12.8781 29.0101 12.5298 29.0101 12.0068C29.0101 11.5404 29.3016 11.0906 30.1511 11.0906H31.5673L31.2611 11.7451H30.0363C29.8022 11.7451 29.7301 11.868 29.7301 11.9853C29.7301 12.1058 29.8191 12.2389 29.998 12.2389H30.687C31.3243 12.2389 31.6008 12.6003 31.6008 13.0737C31.6008 13.5827 31.2926 13.9995 30.6523 13.9995H29.1024Z"
        fill="#016FD0"
      />
      <rect
        x="0.349951"
        y="0.15"
        width="37.7"
        height="19.7"
        rx="3.85"
        stroke="#D9D9D9"
        strokeWidth="0.3"
      />
    </g>
  </svg>
);

export const MasterCard = ({ style }: Props): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 120 80"
    style={{ ...style }}
  >
    <g fill="none" fillRule="evenodd">
      <rect width="120" height="80" fill="#FFF" rx="4" />
      <path fill="#FF5F00" d="M50.014 58.573h20.695v-37.19H50.014z" />
      <path
        fill="#EB001B"
        d="M51.328 39.979c0-7.545 3.532-14.265 9.033-18.596a23.55 23.55 0 00-14.617-5.056c-13.062 0-23.65 10.589-23.65 23.652 0 13.062 10.588 23.651 23.65 23.651a23.55 23.55 0 0014.617-5.056c-5.5-4.33-9.033-11.05-9.033-18.595"
      />
      <path
        fill="#F79E1B"
        d="M97.89 54.635v-.918h-.24l-.275.631-.276-.631h-.24v.918h.17v-.693l.258.597h.176l.259-.598v.694h.168zm-1.517 0v-.762h.307v-.155h-.782v.155h.307v.762h.168zm2.256-14.656c0 13.062-10.588 23.651-23.65 23.651a23.55 23.55 0 01-14.618-5.056c5.502-4.33 9.034-11.05 9.034-18.595 0-7.545-3.532-14.265-9.034-18.596a23.55 23.55 0 0114.618-5.056c13.062 0 23.65 10.589 23.65 23.652"
      />
    </g>
  </svg>
);

export const MasterCardV2 = ({ style }: Props): React.ReactElement => (
  <svg
    width="39"
    height="20"
    viewBox="0 0 39 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <g id="mastercard">
      <rect
        x="0.750098"
        y="0.15"
        width="37.7"
        height="19.7"
        rx="3.85"
        fill="white"
      />
      <g id="mastercard-2">
        <path
          id="Shape"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.9628 14.8496V16.1811V16.9198H27.6413V16.7405C27.5395 16.8734 27.385 16.9569 27.1748 16.9569C26.7607 16.9569 26.436 16.6323 26.436 16.1815C26.436 15.7306 26.7609 15.406 27.1748 15.406C27.385 15.406 27.5395 15.4894 27.6413 15.6224V14.8496H27.9628ZM15.9147 15.4427V16.1813H15.9143V16.92H15.5935V16.7407C15.4916 16.8736 15.337 16.9571 15.127 16.9571C14.7129 16.9571 14.3882 16.6325 14.3882 16.1817C14.3882 15.7308 14.713 15.4062 15.127 15.4062C15.3371 15.4062 15.4916 15.4896 15.5935 15.6226V15.4427H15.9147ZM14.7194 16.1808C14.7194 15.9212 14.8894 15.708 15.1674 15.708C15.4331 15.708 15.6123 15.912 15.6123 16.1808C15.6123 16.4495 15.4331 16.6535 15.1674 16.6535C14.8894 16.6535 14.7194 16.4403 14.7194 16.1808ZM28.6038 16.7498C28.5756 16.7221 28.5376 16.7066 28.498 16.7066L28.4985 16.7051C28.4782 16.7049 28.4581 16.7089 28.4394 16.7168C28.4215 16.7239 28.4053 16.7346 28.3917 16.7483C28.3781 16.7616 28.3672 16.7774 28.3598 16.795C28.3443 16.8313 28.3443 16.8724 28.3598 16.9088C28.3671 16.9267 28.3778 16.9431 28.3912 16.957C28.405 16.9704 28.4212 16.9811 28.439 16.9885C28.4577 16.9963 28.4778 17.0003 28.498 17.0002C28.5181 17.0003 28.5379 16.9963 28.5563 16.9885C28.5739 16.9809 28.59 16.9702 28.6038 16.957C28.6172 16.9436 28.628 16.9277 28.6356 16.9103C28.6512 16.8739 28.6512 16.8328 28.6356 16.7965C28.6282 16.779 28.6174 16.7631 28.6038 16.7498ZM28.498 16.9665C28.5132 16.9667 28.5282 16.9636 28.5422 16.9575C28.5556 16.9517 28.5678 16.9435 28.5782 16.9331C28.5885 16.9228 28.5968 16.9106 28.6026 16.8972C28.6144 16.8686 28.6144 16.8366 28.6026 16.8081C28.5967 16.7947 28.5885 16.7825 28.5782 16.7721C28.5678 16.7618 28.5556 16.7535 28.5422 16.7477C28.5282 16.742 28.5131 16.7391 28.498 16.7393C28.4826 16.7391 28.4673 16.742 28.453 16.7477C28.4393 16.7534 28.4268 16.7617 28.4162 16.7721C28.3836 16.8055 28.3742 16.8551 28.3922 16.8981C28.3976 16.9116 28.4058 16.9238 28.4162 16.934C28.4268 16.9445 28.4393 16.9527 28.453 16.9584C28.4672 16.9645 28.4825 16.9676 28.498 16.9674V16.9665ZM28.5477 16.795C28.536 16.7866 28.5217 16.7824 28.5074 16.7833L28.5078 16.7834H28.4448V16.9195H28.4738V16.8686H28.4872L28.5286 16.9195H28.5632L28.5182 16.8682C28.5301 16.8674 28.5415 16.8627 28.5505 16.8548C28.5581 16.8476 28.5622 16.8374 28.5618 16.8269C28.5624 16.8146 28.5572 16.8028 28.5477 16.795ZM28.4734 16.8642V16.8092V16.8086H28.5069C28.5133 16.8082 28.5195 16.8107 28.5249 16.8156C28.5294 16.8202 28.5319 16.828 28.5317 16.8361C28.5319 16.8444 28.5294 16.8523 28.5249 16.8571C28.5195 16.8619 28.5132 16.8643 28.5069 16.8642H28.4734ZM26.767 16.1808C26.767 15.9212 26.9371 15.708 27.2152 15.708C27.4811 15.708 27.6601 15.912 27.6601 16.1808C27.6601 16.4495 27.4811 16.6535 27.2152 16.6535C26.9372 16.6535 26.767 16.4403 26.767 16.1808ZM19.9009 15.6934C20.1078 15.6934 20.2407 15.8231 20.2746 16.0515H19.5083C19.5426 15.8383 19.6721 15.6934 19.9009 15.6934ZM19.1724 16.1808C19.1724 15.7202 19.4752 15.4054 19.908 15.4054L19.9078 15.4053C20.3212 15.4053 20.606 15.7203 20.6092 16.1807C20.6092 16.2231 20.6061 16.2627 20.603 16.302L20.6028 16.3041H19.5061C19.5525 16.57 19.7409 16.6658 19.9479 16.6658C20.0961 16.6658 20.2538 16.6103 20.3776 16.5113L20.535 16.7493C20.3557 16.9007 20.152 16.9562 19.9295 16.9562C19.4873 16.9562 19.1724 16.6503 19.1724 16.1808ZM23.7857 16.1808C23.7857 15.9212 23.9558 15.708 24.2338 15.708C24.4994 15.708 24.6787 15.912 24.6787 16.1808C24.6787 16.4495 24.4994 16.6535 24.2338 16.6535C23.9558 16.6535 23.7856 16.4403 23.7856 16.1808H23.7857ZM24.9809 15.4427V16.1808L24.9809 16.1813V16.92H24.6599V16.7407C24.5576 16.8736 24.4035 16.9571 24.1934 16.9571C23.7792 16.9571 23.4546 16.6325 23.4546 16.1817C23.4546 15.7308 23.7794 15.4062 24.1934 15.4062C24.4035 15.4062 24.5576 15.4896 24.6599 15.6226V15.4427H24.9809ZM21.9712 16.1807C21.9712 16.6286 22.2831 16.9561 22.7592 16.9561C22.9816 16.9561 23.1298 16.9066 23.2901 16.78L23.1358 16.5205C23.0153 16.6071 22.8886 16.6534 22.7489 16.6534C22.4925 16.6503 22.304 16.465 22.304 16.1807C22.304 15.8964 22.4925 15.7112 22.7489 15.7079C22.8883 15.7079 23.0149 15.7542 23.1358 15.8409L23.2901 15.5813C23.1295 15.4548 22.9813 15.4053 22.7592 15.4053C22.2831 15.4053 21.9712 15.7327 21.9712 16.1807ZM25.7222 15.6216C25.8057 15.4919 25.9263 15.4053 26.1116 15.4053L26.1114 15.4055C26.1765 15.4055 26.2692 15.4179 26.3403 15.4458L26.2413 15.7485C26.1775 15.723 26.1092 15.7103 26.0404 15.7113C25.8305 15.7113 25.7255 15.8471 25.7255 16.0914V16.9191H25.404V15.4426H25.7222V15.6216ZM17.5028 15.5597C17.3483 15.4579 17.1354 15.4053 16.9005 15.4053C16.5264 15.4053 16.2855 15.5846 16.2855 15.878C16.2855 16.1187 16.4648 16.2672 16.7951 16.3136L16.9468 16.3352C17.1229 16.3599 17.2061 16.4062 17.2061 16.4896C17.2061 16.6038 17.0891 16.6689 16.8694 16.6689C16.647 16.6689 16.4864 16.5979 16.3782 16.5145L16.2273 16.7648C16.4034 16.8946 16.6258 16.9565 16.8667 16.9565C17.2933 16.9565 17.5405 16.7557 17.5405 16.4745C17.5405 16.215 17.3459 16.0792 17.0245 16.0329L16.8731 16.0109C16.7341 15.9929 16.6227 15.9649 16.6227 15.866C16.6227 15.758 16.7277 15.6931 16.9039 15.6931C17.0924 15.6931 17.2749 15.7641 17.3644 15.8197L17.5034 15.5601L17.5028 15.5597ZM21.2573 15.6219C21.3403 15.4922 21.461 15.4055 21.6463 15.4055L21.6461 15.4053C21.7112 15.4053 21.8038 15.4176 21.8749 15.4456L21.776 15.7482C21.7121 15.7227 21.6438 15.7101 21.5751 15.7111C21.3652 15.7111 21.2601 15.8468 21.2601 16.0912V16.9188H20.939V15.4423H21.2573V15.6219ZM18.9058 15.4431H18.3806V14.9951H18.0559V15.4431H17.7563V15.7365H18.0559V16.4101C18.0559 16.7527 18.1889 16.9567 18.5689 16.9567C18.7082 16.9567 18.8688 16.9135 18.9707 16.8426L18.8779 16.5676C18.782 16.6231 18.677 16.6511 18.5935 16.6511C18.433 16.6511 18.3806 16.5521 18.3806 16.404V15.7368H18.9058V15.4431ZM14.1045 15.9923V16.919L13.7791 16.9182V16.0965C13.7791 15.8462 13.6745 15.7072 13.4552 15.7072C13.242 15.7072 13.0938 15.8434 13.0938 16.0997V16.9184H12.7691V16.0967C12.7691 15.8464 12.6612 15.7074 12.4479 15.7074C12.2283 15.7074 12.0862 15.8436 12.0862 16.0999V16.9186H11.7622V15.4421H12.0836V15.6246C12.2043 15.4517 12.3585 15.4054 12.5162 15.4054C12.7419 15.4054 12.9025 15.5044 13.0043 15.6681C13.1405 15.4609 13.3349 15.4022 13.5235 15.4054C13.8821 15.4085 14.1045 15.6434 14.1045 15.9923Z"
          fill="#231F20"
        />
        <path
          id="Shape_2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.3002 11.8275V12.0064H28.2998H28.2602V11.8275H28.1882V11.791H28.3722V11.8275H28.3002ZM28.6574 11.791V12.0069H28.618V11.8439L28.5572 11.9846H28.5158L28.4549 11.8443V12.0069H28.415V11.791H28.4714L28.5361 11.9392L28.6012 11.791H28.6574Z"
          fill="#F79410"
        />
        <path
          id="Path"
          d="M22.2641 12.9331H17.397V4.18848H22.2642L22.2641 12.9331Z"
          fill="#FF5F00"
        />
        <path
          id="Path_2"
          d="M17.7057 8.56146C17.7057 6.78762 18.5365 5.20747 19.8302 4.18916C18.8509 3.41721 17.6397 2.99825 16.3927 3.00009C13.3207 3.00009 10.8306 5.48996 10.8306 8.56146C10.8306 11.633 13.3207 14.1228 16.3927 14.1228C17.6398 14.1247 18.851 13.7057 19.8303 12.9338C18.5367 11.9156 17.7057 10.3354 17.7057 8.56146Z"
          fill="#EB001B"
        />
        <path
          id="Path_3"
          d="M28.8305 8.56138C28.8305 11.6329 26.3403 14.1228 23.2683 14.1228C22.0211 14.1246 20.8098 13.7056 19.8303 12.9337C21.1244 11.9154 21.9551 10.3353 21.9551 8.56138C21.9551 6.78745 21.1244 5.20739 19.8303 4.18908C20.8098 3.41715 22.0211 2.9982 23.2683 3.00001C26.3402 3.00001 28.8304 5.48988 28.8304 8.56138"
          fill="#F79E1B"
        />
      </g>
      <rect
        x="0.750098"
        y="0.15"
        width="37.7"
        height="19.7"
        rx="3.85"
        stroke="#D9D9D9"
        strokeWidth="0.3"
      />
    </g>
  </svg>
);

export const Visa = ({ style }: Props): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 120 80"
    style={{ ...style }}
  >
    <g fill="none" fillRule="evenodd">
      <rect width="120" height="60" y="10" fill="#FFF" rx="4" />
      <path
        fill="#1A1F71"
        d="M0 4.01A4.002 4.002 0 013.995 0H116a4 4 0 014 4.01V10H0V4.01z"
      />
      <path
        fill="#F7B600"
        d="M0 70h120v5.99c0 2.215-1.787 4.01-3.99 4.01H3.997A3.999 3.999 0 010 75.99V70z"
      />
      <g fill="#1A1F71">
        <path d="M53.747 52.825h-7.033L51.11 27.15h7.033l-4.396 25.675M41.407 27.15l-6.39 17.659-.755-3.803v.001l-2.255-11.545s-.272-2.312-3.18-2.312h-10.56l-.124.434s3.23.67 7.01 2.936l5.822 22.305h6.982L48.619 27.15h-7.212m44.355 17.775l3.657-9.875 2.057 9.875h-5.714zm14.286 7.9L94.904 27.15h-7.07c-2.386 0-2.966 1.913-2.966 1.913l-9.582 23.762h6.696l1.34-3.813h8.168l.753 3.813h7.805zM76.282 33.559l.908-5.328s-2.805-1.081-5.73-1.081c-3.162 0-10.67 1.401-10.67 8.211 0 6.409 8.812 6.489 8.812 9.853 0 3.365-7.903 2.764-10.511.641l-.948 5.569s2.844 1.401 7.192 1.401c4.347 0 10.907-2.283 10.907-8.492 0-6.45-8.892-7.05-8.892-9.853 0-2.804 6.205-2.444 8.932-.921" />
        <path d="M33.381 40.975l-2.132-11.518s-.257-2.307-3.006-2.307H18.26l-.116.433s4.799 1.048 9.403 4.97c4.4 3.749 5.835 8.422 5.835 8.422" />
      </g>
    </g>
  </svg>
);

export const VisaV2 = ({ style }: Props): React.ReactElement => (
  <svg
    width="38"
    height="20"
    viewBox="0 0 38 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <g id="Visa">
      <rect
        x="0.15"
        y="0.15"
        width="37.7"
        height="19.7"
        rx="3.85"
        fill="white"
      />
      <g id="visa">
        <g id="Group">
          <path
            id="Shape"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.4663 6.33682L24.1868 7.99648C23.3488 7.52202 21.4415 7.40977 21.4413 8.28363C21.4413 8.63079 21.8728 8.86955 22.393 9.15731C23.1818 9.59373 24.1743 10.1429 24.1743 11.3538C24.1743 13.2889 22.1582 13.9998 20.8218 13.9998C19.4858 13.9998 18.6113 13.5634 18.6113 13.5634L18.9025 11.8281C19.7043 12.4894 22.1339 12.6774 22.1339 11.6286C22.1339 11.1879 21.6556 10.928 21.101 10.6266C20.3358 10.2108 19.4252 9.71602 19.4252 8.55838C19.4252 6.43626 21.7331 5.99984 22.7049 5.99984C23.6039 5.99984 24.4663 6.33682 24.4663 6.33682ZM13.7984 6.13754L11.9314 11.4533L11.7105 10.3086L11.7107 10.309L11.0517 6.8334C11.0517 6.8334 10.972 6.13754 10.1227 6.13754H7.03622L7 6.2684C7 6.2684 7.94386 6.47017 9.04849 7.15177L10.7499 13.8663H12.7903L15.906 6.13754H13.7984ZM17.4042 13.8661H15.4458L16.6697 6.13754H18.6283L17.4042 13.8661ZM31 13.8663H29.2018L28.9724 12.7183H26.4829L26.0747 13.8663H24.0332L26.9539 6.7135C26.9539 6.7135 27.131 6.13754 27.858 6.13754H29.4322L31 13.8663ZM27.0469 11.1323L28.0758 8.24007L28.6547 11.1323H27.0469Z"
            fill="#2566AF"
          />
        </g>
        <path
          id="Path"
          d="M11.7107 10.2718L11.0517 6.82638C11.0517 6.82638 10.972 6.13656 10.1227 6.13656H7.03622L7 6.26628C7 6.26628 8.4835 6.57943 9.90644 7.7527C11.267 8.87413 11.7107 10.2718 11.7107 10.2718Z"
          fill="#E6A540"
        />
      </g>
      <rect
        x="0.15"
        y="0.15"
        width="37.7"
        height="19.7"
        rx="3.85"
        stroke="#D9D9D9"
        strokeWidth="0.3"
      />
    </g>
  </svg>
);

export const Twint = ({ style }: Props): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 120 80"
    style={{ ...style }}
  >
    <defs>
      <radialGradient
        id="twint-a"
        cx="22.357%"
        cy="8.811%"
        r="113.202%"
        fx="22.357%"
        fy="8.811%"
      >
        <stop offset="0%" stopColor="#FC0"></stop>
        <stop offset="9.157%" stopColor="#FFC800"></stop>
        <stop offset="17.39%" stopColor="#FFBD00"></stop>
        <stop offset="25.28%" stopColor="#FFAB00"></stop>
        <stop offset="32.95%" stopColor="#FF9100"></stop>
        <stop offset="40.46%" stopColor="#FF7000"></stop>
        <stop offset="47.86%" stopColor="#FF4700"></stop>
        <stop offset="55.03%" stopColor="#FF1800"></stop>
        <stop offset="58.22%" stopColor="red"></stop>
        <stop offset="100%" stopColor="red"></stop>
      </radialGradient>
      <radialGradient
        id="twint-b"
        cx="2.552%"
        cy="14.432%"
        r="139.457%"
        fx="2.552%"
        fy="14.432%"
      >
        <stop offset="0%" stopColor="#00B4E6"></stop>
        <stop offset="20.1%" stopColor="#00B0E3"></stop>
        <stop offset="38.98%" stopColor="#01A5DB"></stop>
        <stop offset="57.37%" stopColor="#0292CD"></stop>
        <stop offset="75.46%" stopColor="#0377BA"></stop>
        <stop offset="93.16%" stopColor="#0455A1"></stop>
        <stop offset="100%" stopColor="#054696"></stop>
      </radialGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <rect width="120" height="80" fill="#000" rx="4"></rect>
      <g fillRule="nonzero">
        <path
          fill="#FFF"
          d="M39.48 47.99c0 .426-.3.952-.66 1.155l-12.86 7.51c-.36.224-.96.224-1.32 0l-12.86-7.51c-.36-.223-.66-.729-.66-1.154V32.948c0-.425.3-.951.66-1.154l12.86-7.51c.36-.223.96-.223 1.32 0l12.86 7.51c.36.223.66.73.66 1.154v15.043zm71.4-13.948H99.36v2.773h4.12V48.72h3.26V36.815h4.14zm-52.32 0H47.04v2.773h4.14V48.72h3.26V36.815h4.12zm33.34-.466c-3.62 0-5.64 2.349-5.64 5.73v9.414h3.22v-9.495c0-1.478.86-2.612 2.46-2.612 1.58 0 2.44 1.336 2.44 2.612v9.495h3.22v-9.414c0-3.381-2.08-5.73-5.7-5.73zm-12.18.466V48.72h3.24V34.042zm-10.92 5.83l.12.648 3.02 8.2h1.32l4.12-14.678H74.2l-1.98 7.713-.1.83-.16-.83-2.64-7.713h-1.04l-2.62 7.713-.16.83-.12-.83-1.96-7.713h-3.18l4.12 14.678h1.32l3.02-8.2.1-.648"
        ></path>
        <path
          fill="url(#twint-a)"
          d="M20.98 16.52l-3.34 4.98-1.72-2.672 1.98-2.996c.36-.526 1.16-2.004.24-4.009-.74-1.62-2.34-2.409-3.74-2.409-1.4 0-2.94.729-3.74 2.41-.92 1.923-.12 3.441.22 3.947 0 0 1.1 1.64 2.02 3.017l1.5 2.186 2.24 3.462c.02.02.38.567 1 .567.6 0 .96-.547 1.02-.607l5.26-7.876h-2.94zm-6.58.122s-.88-1.357-1.44-2.288c-.62-1.012.08-2.51 1.44-2.51 1.38 0 2.06 1.498 1.44 2.51-.56.952-1.44 2.288-1.44 2.288z"
          transform="translate(11 24)"
        ></path>
        <path
          fill="url(#twint-b)"
          d="M11.16 21.339l-3.3-4.677s-.88-1.356-1.44-2.288c-.62-1.012.08-2.51 1.44-2.51.18 0 .34.02.48.06L9.5 9.78a4.334 4.334 0 00-1.64-.345c-1.4 0-2.94.73-3.74 2.41-.92 1.923-.12 3.441.22 3.947l5.76 8.645c.04.081.42.628 1.02.628.62 0 .96-.527 1.02-.608l1.74-2.672-1.5-2.227-1.22 1.782z"
          transform="translate(11 24)"
        ></path>
      </g>
    </g>
  </svg>
);

export const TwintV2 = ({ style }: Props): React.ReactElement => (
  <svg
    width="38"
    height="20"
    viewBox="0 0 38 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <g id="Group 153">
      <path
        id="Vector"
        d="M34 0H4C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H34C36.2091 20 38 18.2091 38 16V4C38 1.79086 36.2091 0 34 0Z"
        fill="black"
      />
      <g id="Group">
        <path
          id="Shape"
          d="M12.7189 13.3009C12.7189 13.4322 12.6257 13.5886 12.5139 13.6511L8.56436 15.9524C8.45258 16.0149 8.26628 16.0149 8.1545 15.9524L4.20493 13.6511C4.09315 13.5886 4 13.426 4 13.3009V8.69836C4 8.56704 4.09315 8.4107 4.20493 8.34817L8.1545 6.0469C8.26628 5.98437 8.45258 5.98437 8.56436 6.0469L12.5139 8.34817C12.6257 8.4107 12.7189 8.57329 12.7189 8.69836V13.3009ZM34.6464 9.02979H31.1129V9.88026H32.3798V13.5198H33.3796V9.88026H34.6464V9.02979ZM18.5811 9.02979H15.0414V9.88026H16.3083V13.5198H17.3081V9.88026H18.5749L18.5811 9.02979ZM28.8152 8.89222C27.7036 8.89222 27.0826 9.61136 27.0826 10.6432V13.526H28.0762V10.6244C28.0762 10.1742 28.3371 9.82398 28.8277 9.82398C29.3182 9.82398 29.5729 10.2367 29.5729 10.6244V13.526H30.5602V10.6432C30.5727 9.60511 29.933 8.89222 28.8152 8.89222ZM25.083 9.02979V13.5198H26.0704V9.02979H25.083ZM21.7234 10.812L21.7544 11.0121L22.6859 13.526H23.0896L24.3564 9.03605H23.3815L22.7791 11.3936L22.7418 11.65L22.6922 11.3936L21.8849 9.03605H21.5619L20.7546 11.3936L20.7049 11.65L20.6739 11.3936L20.0715 9.03605H19.0903L20.3572 13.526H20.7608L21.6923 11.0121L21.7234 10.812Z"
          fill="white"
        />
        <path
          id="Shape_1_"
          d="M10.4211 11.0121L9.39021 12.5379L8.86236 11.725L9.47094 10.8057C9.58272 10.6432 9.82492 10.1929 9.54546 9.58007C9.3219 9.07979 8.83131 8.84216 8.39661 8.84216C7.96191 8.84216 7.49616 9.06729 7.24776 9.58007C6.9621 10.1741 7.2105 10.6306 7.31607 10.787C7.31607 10.787 7.65762 11.2873 7.93707 11.7062L8.39661 12.3754L9.08592 13.4384C9.09213 13.4447 9.1977 13.6135 9.39021 13.6135C9.5703 13.6135 9.6883 13.4447 9.70072 13.4322L11.3153 11.0246H10.4211V11.0121ZM8.3904 11.0496C8.3904 11.0496 8.12337 10.6369 7.94328 10.3492C7.75698 10.0428 7.96191 9.58007 8.3904 9.58007C8.81268 9.58007 9.02382 10.0428 8.83752 10.3492C8.66364 10.6369 8.3904 11.0496 8.3904 11.0496Z"
          fill="url(#paint0_radial_1373_1810)"
        />
        <path
          id="Vector_2"
          d="M7.40298 12.4879L6.39075 11.0559C6.39075 11.0559 6.12372 10.6432 5.94363 10.3555C5.75733 10.0491 5.96226 9.58632 6.39075 9.58632C6.44664 9.58632 6.49011 9.59258 6.53979 9.60508L6.89376 8.94847C6.7323 8.87968 6.55221 8.84216 6.39075 8.84216C5.96226 8.84216 5.4903 9.06729 5.2419 9.58007C4.95624 10.1741 5.20464 10.6306 5.31021 10.787L7.08006 13.4322C7.09869 13.451 7.21047 13.6198 7.39677 13.6198C7.58307 13.6198 7.69486 13.4572 7.70728 13.4384L8.24134 12.6192L7.7818 11.9439L7.40298 12.4879Z"
          fill="url(#paint1_radial_1373_1810)"
        />
      </g>
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_1373_1810"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(8.05637 9.26094) scale(4.75889 5.4094)"
      >
        <stop stopColor="#FFCC00" />
        <stop offset="0.09157" stopColor="#FFC800" />
        <stop offset="0.1739" stopColor="#FFBD00" />
        <stop offset="0.2528" stopColor="#FFAB00" />
        <stop offset="0.3295" stopColor="#FF9100" />
        <stop offset="0.4046" stopColor="#FF7000" />
        <stop offset="0.4786" stopColor="#FF4700" />
        <stop offset="0.5503" stopColor="#FF1800" />
        <stop offset="0.5822" stopColor="#FF0000" />
        <stop offset="1" stopColor="#FF0000" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_1373_1810"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(5.18792 9.53722) scale(4.36335 6.65281)"
      >
        <stop stopColor="#00B4E6" />
        <stop offset="0.201" stopColor="#00B0E3" />
        <stop offset="0.3898" stopColor="#01A5DB" />
        <stop offset="0.5737" stopColor="#0292CD" />
        <stop offset="0.7546" stopColor="#0377BA" />
        <stop offset="0.9316" stopColor="#0455A1" />
        <stop offset="1" stopColor="#054696" />
      </radialGradient>
    </defs>
  </svg>
);

export const PostePay = ({ style }: Props): React.ReactElement => (
  <svg
    viewBox="0 0 80 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ ...style }}
  >
    <g clipPath="url(#poste_pay)">
      <path d="M48 0H0v13.073h48V0z" fill="#F4E624" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.775 8.505c-.69.616-1.869.825-2.567.127-.293-.293-.442-.653-.497-1.061-.092-.694.208-1.2.781-1.57.813-.525 1.942-.487 2.887-.484.014-.208.062-.414.062-.625 0-.349-.69-.477-.9-.21-.087.11-.162.325-.228.458l-.03.06H34.56l.017-.124c.038-.264.138-.506.3-.719.417-.546 1.157-.789 1.818-.845.647-.054 1.512.057 2.025.49.488.413.534 1.266.4 1.847l-.4 1.732c-.095.412-.13.886-.13 1.308v.108h-1.815v-.492zm.398-2.106h-.224c-.208 0-.432-.006-.632.06-.16.054-.369.12-.49.241l-.01.01-.012.007a.74.74 0 00-.228.222c-.135.2-.261.647.022.788l.015.008.013.012c.077.077.22.102.323.102.121 0 .24 0 .352-.055.167-.083.314-.132.425-.297l.005-.009.008-.007c.294-.295.415-.678.433-1.082zM40.5 8.865l-.948-5.28h1.756l.436 3.306 1.871-3.306h1.718L42.04 9.143l-.963 1.72h-1.932L40.5 8.865zM30.292 4.023c.436-.385.92-.638 1.537-.638.47 0 .958.143 1.28.502.33.37.447.845.493 1.328.013.137.013.274.013.412 0 .804-.18 1.647-.63 2.323-.593.888-2.03 1.467-3.009.9a1.607 1.607 0 01-.498-.471l-.56 2.55h-1.753l.028-.13c.515-2.348.995-4.704 1.465-7.061l.018-.087h1.645l-.029.372zm-.168 1.254c-.278.508-.351 1.103-.32 1.674.023.397.175.869.638.898.457.03.835-.363 1.024-.74.141-.283.262-.595.324-.905.084-.421.238-1.162-.104-1.503-.496-.496-1.3.1-1.561.576zM7.255 8.715c-.574.424-1.61.45-2.236.137a1.804 1.804 0 01-.564-.455l-.569 2.466H2.667l1.579-7.278h1.07l-.05.606a2.521 2.521 0 011.665-.673c.495 0 .922.144 1.275.498.374.374.598.8.631 1.336.027.42-.021.83-.137 1.235-.117.411-.249.797-.479 1.16-.252.4-.54.752-.967.968zm.243-2.398c.125-.31.126-.63.126-.959 0-.288-.123-.516-.307-.728-.6-.693-1.716-.037-2.02.64-.343.766-.522 1.09-.522 1.954 0 .286.105.46.301.656.195.196.384.236.657.236.67 0 1.033-.248 1.373-.814.18-.3.318-.623.386-.966l.002-.01.004-.009zm6.196-2.375c.41.335.596.756.639 1.274.037.457-.011.93-.137 1.371-.123.43-.306.85-.546 1.227-.257.407-.545.69-.976.905-.79.396-2.3.397-2.984-.216-.376-.336-.57-.842-.635-1.332-.065-.488.002-.971.136-1.442.129-.45.327-.938.62-1.304.856-1.07 2.802-1.366 3.883-.483zM10.699 8.01c.227.207.5.309.806.244.944-.201 1.684-2.03 1.679-2.895-.002-.306-.082-.571-.302-.79-.645-.647-1.656.022-2.03.645a2.853 2.853 0 00-.386 1.028c-.088.53-.211 1.364.233 1.768zm7.23-3.167c-.036-.112-.107-.338-.206-.388a1.234 1.234 0 00-.551-.122c-.26 0-.457.038-.674.182-.136.091-.29.23-.28.41.02.345.581.678.863.801.4.175.92.443 1.233.755.212.213.343.502.364.802.04.557-.186.978-.646 1.295-.507.35-1.186.486-1.793.486-.472 0-.98-.104-1.388-.349-.32-.191-.555-.456-.603-.836-.033-.264.03-.493.087-.746l.019-.084h1.26l-.079.156c-.097.196-.063.68.152.789.19.095.408.122.618.122.28 0 .633-.043.879-.186.213-.124.28-.265.28-.506 0-.126-.083-.239-.169-.324-.179-.179-.537-.344-.766-.444-.36-.156-.887-.41-1.166-.689a1.27 1.27 0 01-.364-.801c-.036-.503.13-.881.5-1.22.451-.411 1.015-.494 1.606-.494.43 0 1.025.037 1.392.284.326.22.502.484.58.868l.001.01V5.2H17.93v-.356zm2.305-.31h-.942l.264-.882h.927l.262-1.178 1.237-.33-.343 1.442h1.127l-.176.882h-1.135c-.05.21-.107.419-.16.627-.09.358-.177.717-.254 1.077-.06.28-.342 1.63-.13 1.843.07.068.298.102.391.102.057 0 .114-.004.17-.01.16-.016.34-.057.497-.057h.14l-.258.948h-.082c-.247 0-.499.043-.745.063-.396.033-.773.013-1.114-.214-.601-.4-.379-1.267-.245-1.846l.569-2.467zm3.349 1.8c-.517 1.986 1.839 2.09 2.145.865l.02-.082h1.356l-.034.134c-.139.554-.436.95-.911 1.263-.863.567-2.358.662-3.192-.006-.394-.316-.568-.78-.639-1.268-.068-.47.015-.922.136-1.376.313-1.167 1.215-2.287 2.462-2.486.116-.019.233-.029.35-.03 1.679-.01 2.503 1.377 1.991 2.912l-.024.073h-3.66zm2.637-.75c.338-1.207-1.073-1.784-1.91-.948-.276.276-.42.578-.484.949h2.393z"
        fill="#1D60B4"
      />
    </g>
    <defs>
      <clipPath id="poste_pay">
        <path fill="#fff" d="M0 0h48v13H0z" />
      </clipPath>
    </defs>
  </svg>
);
